import React from "react";
import api from "./api";
import { PuffLoader } from "react-spinners";

const { useState, useCallback, useMemo, useEffect } = React;

const useAxiosLoader = () => {
  const [counter, setCounter] = useState(0);

  const inc = useCallback(
    () => setCounter((counter) => counter + 1),
    [setCounter]
  ); // add to counter
  const dec = useCallback(
    () => setCounter((counter) => counter - 1),
    [setCounter]
  ); // remove from counter

  const interceptors = useMemo(
    () => ({
      request: (config) => {
        inc();
        return config;
      },
      response: (response) => {
        dec();
        return response;
      },
      error: (error) => {
        dec();
        return Promise.reject(error);
      },
    }),
    [inc, dec]
  ); // create the interceptors

  useEffect(() => {
    // add request interceptors
    api.interceptors.request.use(interceptors.request, interceptors.error);
    // add response interceptors
    api.interceptors.response.use(interceptors.response, interceptors.error);
    return () => {
      // remove all intercepts when done
      api.interceptors.request.eject(interceptors.request);
      api.interceptors.request.eject(interceptors.error);
      api.interceptors.response.eject(interceptors.response);
      api.interceptors.response.eject(interceptors.error);
    };
  }, [interceptors]);

  return [counter > 0];
};

const GlobaLoader = () => {
  const [loading] = useAxiosLoader();

  return (
    <>
      {loading ? (
        <PuffLoader
          color="hsla(168, 82%, 29%, 1)"
          loading
          size={150}
          speedMultiplier={2}
        />
      ) : null}
    </>
  );
};

export default GlobaLoader;
export { useAxiosLoader };
